module.exports = __webpack_public_path__ + "img/product-placeholder-64.8d4149c.png";